import React, { useEffect, useRef, Children, createElement } from 'react';
import { motion } from 'framer-motion';
export function VideoTestimonials() {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    // Load Wistia player script
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.head.appendChild(playerScript);
    // Load first video embed script
    const embed1 = document.createElement('script');
    embed1.src = 'https://fast.wistia.com/embed/p8jy9nsna3.js';
    embed1.async = true;
    embed1.type = 'module';
    document.head.appendChild(embed1);
    // Load second video embed script
    const embed2 = document.createElement('script');
    embed2.src = 'https://fast.wistia.com/embed/dbhn9hik0o.js';
    embed2.async = true;
    embed2.type = 'module';
    document.head.appendChild(embed2);
    // Load third video embed script
    const embed3 = document.createElement('script');
    embed3.src = 'https://fast.wistia.com/embed/vamtpx7w3r.js';
    embed3.async = true;
    embed3.type = 'module';
    document.head.appendChild(embed3);
    return () => {
      // Cleanup scripts on unmount
      if (playerScript.parentNode) document.head.removeChild(playerScript);
      if (embed1.parentNode) document.head.removeChild(embed1);
      if (embed2.parentNode) document.head.removeChild(embed2);
      if (embed3.parentNode) document.head.removeChild(embed3);
    };
  }, []);
  const testimonials = [{
    mediaId: 'p8jy9nsna3',
    name: 'Alden',
    title: 'Executive',
    company: 'Premier Roofing',
    quote: "They helped us hire nearly 100 new sales reps in one season, and many are now among our top performers. I have confidence knowing I don't just have a recruiting vendor. I have a true business partner."
  }, {
    mediaId: 'dbhn9hik0o',
    name: 'Nolan',
    title: 'Market Owner',
    company: 'Elite Windows',
    quote: 'It took the headache out of recruiting and gave me my time back. In our first month, we brought on eight new reps. Three months later, six of them are still here and producing. We are now the top office in the company.'
  }, {
    mediaId: 'vamtpx7w3r',
    name: 'Russell',
    title: 'VP of Sales',
    company: 'Shared Solar Advisors',
    quote: 'They helped us tighten our back-end so we could grow based on real, reliable, predictable systems instead of hopes, dreams, and shoestrings. We stopped second-guessing our training and started keeping the right people.'
  }];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <section id="testimonials" className="section-padding bg-navy" data-id="element-975">
      <div className="container-custom" data-id="element-976">
        <div className="max-w-6xl mx-auto" data-id="element-977">
          <motion.div className="text-center mb-12" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5
        }} data-id="element-978">
            <div className="inline-block bg-slate/10 text-slate px-4 py-2 rounded text-sm font-semibold mb-6" data-id="element-979">
              Testimonials & Case Studies
            </div>
            <h2 className="text-white mb-6" data-id="element-980">Hear From Our Partners</h2>
            <p className="text-xl text-gray-300 leading-relaxed" data-id="element-981">
              Real founders and executives sharing their experience with the
              HIRE Advantage.
            </p>
          </motion.div>

          {/* Videos Grid */}
          <motion.div className="grid md:grid-cols-3 gap-6 max-w-6xl mx-auto mb-12" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
          once: true,
          margin: '-100px'
        }} data-id="element-982">
            {testimonials.map((testimonial, index) => <motion.div key={index} className="flex justify-center" variants={itemVariants} data-id="element-983">
                <div className="bg-navy-light rounded p-4 border-2 border-slate/20 w-full" data-id="element-984">
                  {/* Video Container - Portrait 9:16 aspect ratio */}
                  <div className="bg-navy rounded overflow-hidden mb-4" style={{
                aspectRatio: '9/16'
              }} data-id="element-985">
                    <style data-id="element-986">{`
                      wistia-player[media-id='${testimonial.mediaId}']:not(:defined) { 
                        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/${testimonial.mediaId}/swatch'); 
                        display: block; 
                        filter: blur(5px); 
                        padding-top: 177.78%; 
                      }
                    `}</style>
                    <wistia-player media-id={testimonial.mediaId} aspect="0.5625" className="w-full h-full" data-id="element-987"></wistia-player>
                  </div>

                  {/* Partner Info */}
                  <div className="text-center mb-4" data-id="element-988">
                    <h3 className="text-white font-bold text-lg mb-1" data-id="element-989">
                      {testimonial.name}
                    </h3>
                    <p className="text-slate text-sm font-semibold" data-id="element-990">
                      {testimonial.title}
                    </p>
                    <p className="text-gray-400 text-sm" data-id="element-991">
                      {testimonial.company}
                    </p>
                  </div>

                  {/* Quote */}
                  <div className="bg-navy/50 rounded p-4 border border-slate/10" data-id="element-992">
                    <p className="text-gray-300 text-sm italic leading-relaxed" data-id="element-993">
                      "{testimonial.quote}"
                    </p>
                  </div>
                </div>
              </motion.div>)}
          </motion.div>
        </div>
      </div>
    </section>;
}